export const NavBarOptions = [
  {
    key: 1,
    title: "Autorizaciones",
    redirectTo: "/autorizacion",
    hasSubmenu: true,
    submenu: [
      {
        subtitle: "Solicitar Autorización",
        redirectTo: "/autorizacion",
      },
      {
        subtitle: "Búsqueda Avanzada",
        redirectTo: "/busqueda-autorizacion",
      },
    ],
  },
  {
    key: 2,
    title: "Precertificaciones",
    redirectTo: "/confirmar-precertificacion",
    hasSubmenu: true,
    submenu: [
      {
        subtitle: "Confirmar",
        redirectTo: "/confirmar-precertificacion",
      },
      {
        subtitle: "Cancelar",
        redirectTo: "/cancelar-precertificacion",
      },
    ],
  },
  {
    key: 3,
    title: "Stand Virtual",
    redirectTo: process.env.REACT_APP_STAND_VIRTUAL_URL,
    hasSubmenu: false,
    isStandVirtual: true,
  },
  {
    key: 4,
    title: "Promoción y Prevención",
    redirectTo: "/autorizacion",
    hasSubmenu: false,
    isPyp: true,
    program: "pyp",
  },
  {
    key: 5,
    title: "Crónicos Complejos",
    redirectTo: "/autorizacion",
    hasSubmenu: false,
    isCc: true,
    program: "cc",
  },
  {
    key: 6,
    title: "Cero Tramite",
    redirectTo: "/autorizacion",
    hasSubmenu: false,
    isCt: true,
    program: "ct",
  },
];
